import { defineMessages } from 'react-intl';

export default defineMessages({
  epargnContitueBrute: {
    id: 'releve_situation.epargn_contituee_brute',
  },
  epargnContitueBruteDescription: {
    id: 'releve_situation.epargn_contituee_brute_description',
  },
  epargnNette: {
    id: 'releve_situation.epargn_nette',
  },
  epargnNetteDescription: {
    id: 'releve_situation.epargn_nette_description',
  },
  taux_preleve: {
    id: 'taux_preleve_capital.title',
  },
  montant_preleve: {
    id: 'montant_frais_preleve.title',
  },
  montant_preleve_description: {
    id: 'montant_frais_preleve.description',
  },
  montantSansParticipation: {
    id: 'epargne_nette_withoutParticipation.title',
  },
  participation_aux_benificaire: {
    id: 'epargne_participation.title',
  },
  participation_aux_benificaire_description: {
    id: 'epargne_participation.description',
  },

  epargne_nette_avec_participation: {
    id: 'epargn_nette.title',
  },
  capitalGaranti: {
    id: 'dashboard_epargn.epargn_capital_garanti',
  },
});
